import { epicRequest, reduxFetchCreator, serverResponse } from 'app'

export type ActionType = {
  digest_email_time: string
  userId: string
}

const getInitialState = () =>
  serverResponse<{ digest_email_time: string }[]>({
    data: [],
  })

const digestEmailTime = reduxFetchCreator<'profileDigestEmailTime', ActionType, ReturnType<typeof getInitialState>>(
  'profileDigestEmailTime',
  getInitialState(),
)

const profileDigestEmailTimeEpic = epicRequest({
  actionType: digestEmailTime.actions.profileDigestEmailTime.type,
  debounce: 1000,
  errorAction: digestEmailTime.actions.profileDigestEmailTimeError,
  fulfilledAction: digestEmailTime.actions.profileDigestEmailTimeFulfilled,
  request: (action: { payload: ActionType }) => ({
    body: action.payload,
    method: 'post',
    url: `user/${action.payload.userId}/profile/digestEmailTime`,
  }),
  untilTypes: digestEmailTime.actions.profileDigestEmailTimeCancel.type,
})

export const actions = {
  ...digestEmailTime.actions,
}

export const epics = [profileDigestEmailTimeEpic]

export const { reducer } = digestEmailTime
